import { render } from "./ProdIcon.vue?vue&type=template&id=571f45c4&scoped=true"
import script from "./ProdIcon.vue?vue&type=script&lang=js"
export * from "./ProdIcon.vue?vue&type=script&lang=js"

import "./ProdIcon.vue?vue&type=style&index=0&id=571f45c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571f45c4"]])

export default __exports__